import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import chatBtnMobile from '../../../assets/images/icon-chat-mobile.svg'
import whatsappIcon from '../../../assets/images/whatsapp-icon.png'
import './chat-button.scss'

const ChatButton = props => {

  const resultQuery = useStaticQuery(
    graphql`
      query REDIRECT_CHAT_QUERY{
        allContentfulNolPaises(filter: {node_locale: {eq: "es-CO"}}) {
          nodes {
            codigoIcu
            redireccionDelChat
          }
        }
      }
    `
  )
  
  const linkRedirect = resultQuery.allContentfulNolPaises.nodes.filter(e => e.codigoIcu === process.env.LOCALE)[0].redireccionDelChat  
  const isWhatsapp = process.env.LOCALE === 'es-EC' || process.env.LOCALE === 'es-AR'

  if (!props.mobile) {

    return (
      <li className="f-btn-nav-chat">
        <a href={linkRedirect} className="f-float-chat" rel="noreferrer noopener" target="_blanck">
          <div className={"f-chat-btn " + (isWhatsapp ? "f-whatsapp-icon" : '')}></div>
          {!isWhatsapp && <label className="f-chat-label">Chat</label>}
        </a>
      </li>
    )
  } else {
    return (
      <div className="f-btn-nav-chat-mobile">

        <a href={linkRedirect} rel="noreferrer noopener" target="_blanck">
          <img className="f-img-chat" src={isWhatsapp ? whatsappIcon : chatBtnMobile} alt="botón de chat" />
        </a>
      </div>
    )
  }
}

export default ChatButton
